import Vue from 'vue'
import { store } from './store/store'
import App from './App'
import router from './router'
import NLoader from './store/nloader'
import axios from 'axios'

import Sidebar from './components/admin/master/Sidebar'
import Header from './components/admin/master/Header'
import Breadcrumb from './components/admin/master/Breadcrumb'
import Footer from './components/admin/master/Footer'
import Pagination from './components/admin/master/Pagination'

import VueTinyTabs from 'vue-tiny-tabs'
Vue.component('vue-tiny-tabs', VueTinyTabs);

Vue.component('app-sidebar', Sidebar);
Vue.component('app-header', Header);
Vue.component('pagination', Pagination);
Vue.component('app-breadcrumb', Breadcrumb);
Vue.component('app-footer', Footer);

Vue.config.productionTip = false

axios.defaults.baseURL = 'https://player.m2list.com/api/'

Vue.mixin({
  methods: {
    notify(type, text) {
        let vm = this
        var opts = {
            title: 'Notification',
            buttons: {
                closer: true,
                sticker: false
            },
            delay: 3000
        };
        switch (type) {
            case 'error_add':
                opts.text = 'Error adding data!';
                opts.addclass = "alert alert-danger alert-styled-left bg-danger alert-arrow-left";
                opts.type = "error";
            break;

            case 'success_add':
                opts.text = 'Add data successfully!';
                opts.addclass = "alert alert-success alert-styled-left bg-success alert-arrow-left";
                opts.type = "success";
            break;

            case 'error_edit':
                opts.text = 'Error updating data!';
                opts.addclass = "alert alert-danger alert-styled-left bg-danger alert-arrow-left";
                opts.type = "error";
            break;

            case 'success_edit': 
                opts.text = 'Update data successfully!';
                opts.addclass = "alert alert-success alert-styled-left bg-success alert-arrow-left";
                opts.type = "success";
            break;

            case 'error_delete':
                opts.text = 'Error deleting data!';
                opts.addclass = "alert alert-danger alert-styled-left bg-danger alert-arrow-left";
                opts.type = "error";
            break;

            case 'success_delete':
                opts.text = 'Delete data successfully!';
                opts.addclass = "alert alert-success alert-styled-left bg-success alert-arrow-left";
                opts.type = "success";
            break;
        }
        new PNotify(opts);
    }
    //end::Notify
  }

 }) 

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js